import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ModelService } from '../services/model.service';

@Injectable()
export class LoginGuard implements CanActivate {

	constructor(
		private modelService: ModelService,
		private router: Router) { }

	public canActivate(): boolean {

		if (this.modelService.getUser().hasToken && this.modelService.getUser().shouldRemember) {
			this.router.navigate(['/hold']);
			return false;
		} //else {
			return true;
		//}
		//return true;
	}
}
